import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import {TeleportDto} from "@/store/place/types";
import TextButton from "@/scenes.ui/text-button";

export class TeleportPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, t: TeleportDto, cancelText: string,
                pickCallback: (roadId: string) => unknown, closeCallback: () => unknown) {
        super(scene, canvas, t.title);

        let self = this;

        let block = TextUtils.addTextByFamily(scene, t.presentText, 0, -160,
            '#ffd465', 16, 'bold', 450, Fonts.MYRIADPRO_REGULAR);
        this.add(block);

        if (!!t) {

            let yy = -115;
            if (t.destinations.length === 1) {
                yy = -65;
            }

            for (let p of t.destinations) {
                let name = TextUtils.addTextByFamily(scene, p.name, 0, yy,
                    '#d6d7d9', 14, 'bold', 450, Fonts.MYRIADPRO_REGULAR);

                let butt = SpriteUtils.addSprite(this.scene, 0, yy + 50, Keys.GREEN_HORIZONTAL_BUTTON).setOrigin(0.5, 0.5);
                let buttText = TextUtils.addTextByFamily(scene, p.action, butt.x / CU.S, butt.y / CU.S,
                    '#ffffff', 18, 'bold', 400, Fonts.MYRIADPRO_REGULAR);

                let roadId = p.roadId;
                butt.setInteractive().on('pointerup', () => {
                    pickCallback(roadId);
                });

                const separator = SpriteUtils.addSprite(this.scene!, 0, yy + 90, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR)
                    .setScale(0.5, 0.5).setOrigin(0.5, 0);

                this.add([name, butt, buttText, separator]);

                yy += 120;
            }
        }

        let tb = new TextButton(this.scene, 0, 190, Keys.UI_BUTTON_BROWN, cancelText)
        tb.setCallback(() => {
            self.close();
            closeCallback();
        })
        this.add(tb);
    }

    protected onClose(): void {

    }

}
